(function() {
    let bulkOrder = [];
    let currentBulkState = null;
    let isUpdatingCart = false;

//OrderNote
    // The note is always rebuilt from the current cart, so adding or removing a product
    // adds or removes exactly that product's block. Updates run one at a time so two
    // writes can never overwrite each other with a stale note.
    let noteQueue = Promise.resolve();

    // Note format (JSON array of objects):
    // [{"bulk_order":true}, {"variant_id":123,"product_title":"...","set_of_content":"...","sap_code":"...","sku":"..."}, ...]
    // The bulk_order object is only present for bulk orders; sap_code / sku are null when the variant has none.
    function buildItemNotes(cart) {
        return cart.items
            .filter((item) => item.properties?.['Set of Content'])
            .map((item) => {
                const sapCode = (item.properties?.['SAP Code'] || '').toString().trim();
                return {
                    variant_id: item.variant_id,
                    product_title: item.product_title,
                    set_of_content: item.properties['Set of Content'].toString().trim(),
                    sap_code: sapCode || null,
                    sku: (item.sku || '').toString().trim() || null,
                };
            });
    }

    function noteHasBulkOrder(note) {
        try {
            const parsed = JSON.parse(note || '[]');
            return Array.isArray(parsed) && parsed.some((entry) => entry && entry.bulk_order === true);
        } catch (e) {
            // Older plain-text notes
            return (note || '').split('\n').some((line) => line.trim() === 'bulk_order');
        }
    }

    function syncCartNote() {
        noteQueue = noteQueue.then(async () => {
            try {
                const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
                if (!cartResponse.ok) throw new Error(`Cart fetch failed: ${cartResponse.status}`);
                const cart = await cartResponse.json();

                // Bulk flag comes from the cart weight check when known, otherwise keep what the note has
                const hasBulk = currentBulkState !== null
                    ? currentBulkState
                    : noteHasBulkOrder(cart.note);

                const entries = [];
                if (hasBulk) entries.push({ bulk_order: true });
                entries.push(...buildItemNotes(cart));
                const note = entries.length ? JSON.stringify(entries) : '';

                if (note === (cart.note || '')) return;

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ note }),
                });
            } catch (error) {
                console.error('Failed to update cart note:', error);
            }
        });
        return noteQueue;
    }

    // Fired by the theme after every add, remove and quantity change
    document.addEventListener('cart:update', () => { syncCartNote(); });

    function updateBulkOrderNote() {
        return syncCartNote();
    }

    async function updateCartWeightUI() {
        if (isUpdatingCart) return;

        const rows = document.querySelectorAll('.cart-items__table-row');
        const checkoutBtn = document.getElementById('checkout');
        const modifyBtn = document.getElementById('modify-cart-btn');
        const modal = document.getElementById('weight-modal');

        if (!checkoutBtn || !modifyBtn) return;

        let totalGrams = 0;
        bulkOrder = [];

        rows.forEach((row) => {
            let rawWeight = row.getAttribute('data-weight') || "0";
            let numericValue = parseFloat(rawWeight.match(/[\d.]+/)) || 0;
            let itemWeightInGrams = rawWeight.toLowerCase().includes('kg')
                ? numericValue * 1000
                : numericValue;

            const qtyInput = row.querySelector('input[name="updates[]"], .quantity__input');
            const qty = parseInt(qtyInput?.value) || 0;
            const title = row.getAttribute('data-title') || "Product";

            totalGrams += (itemWeightInGrams * qty);

            if (qty > 0) {
                bulkOrder.push({ title, qty });
            }
        });

        const shouldBeBulk = totalGrams > 20000;

        // if (currentBulkState !== shouldBeBulk) {
        //     currentBulkState = shouldBeBulk;
        //     isUpdatingCart = true;

        //     try {
        //         await fetch('/cart/update.js', {
        //             method: 'POST',
        //             headers: { 'Content-Type': 'application/json' },
        //             body: JSON.stringify({ note: shouldBeBulk ? 'bulk_order' : '' })
        //         });
        //     } catch (err) {
        //         console.error('Cart update failed:', err);
        //     } finally {
        //         isUpdatingCart = false;
        //     }
        // }

        if (currentBulkState !== shouldBeBulk) {
        currentBulkState = shouldBeBulk;
        isUpdatingCart = true;

        try {
            await updateBulkOrderNote(shouldBeBulk);
        } catch (err) {
            console.error('Cart update failed:', err);
        } finally {
            isUpdatingCart = false;
        }
        }

        if (shouldBeBulk) {
            checkoutBtn.setAttribute('style', 'display: none !important;');
            modifyBtn.setAttribute('style', 'display: block !important;');
        } else {
            checkoutBtn.setAttribute('style', 'display: block !important;');
            modifyBtn.setAttribute('style', 'display: none !important;');
            if (modal && modal.open) modal.close();
        }
    }

    document.addEventListener("click", function(e) {
        const modal = document.getElementById("weight-modal");

        if (e.target.id === "modify-cart-btn" || e.target.closest("#modify-cart-btn")) {
            if (modal) modal.showModal();
        }

        if (e.target.id === "close-weight-modal" || e.target.closest("#close-weight-modal")) {
            if (modal) modal.close();
        }

        if (e.target.id === "bulk-order-btn" || e.target.closest("#bulk-order-btn")) {
            let message = `Hi Team, I want to place a bulk order for the following items:\n\n`;
            bulkOrder.forEach((item, index) => {
                message += `${index + 1}. ${item.title} - ${item.qty} qty\n`;
            });
            message += `\nAny additional comments:\n`;
            // window.location.href = `/pages/contact?cart=${encodeURIComponent(message)}`;
            window.location.href = `/pages/bulk-corporate-gifting-order?cart=${encodeURIComponent(message)}`;
        }
    });

    new MutationObserver(() => { updateCartWeightUI(); }).observe(document.body, {
        childList: true,
        subtree: true
    });

    updateCartWeightUI();
})();


(function () {
    const LIMIT = 20000;

    function getWeight() {
        const form = document.querySelector('product-form-component');
        const raw = (form && form.dataset.weight) || '0';
        const num = parseFloat(raw.match(/[\d.]+/) || '0') || 0;
        return raw.toLowerCase().includes('kg') ? num * 1000 : num;
    }

    function getQty() {
        const input = document.querySelector('.product-details input[name="quantity"], .quantity__input');
        return parseInt(input && input.value) || 1;
    }

    function getButtons() {
        return {
            add: document.querySelector('button[name="add"], .add-to-cart-button'),
            bulk: document.getElementById('product-modify-btn'),
            buyNow: document.querySelector('.shopify-payment-button, button[name="buy_now"]')
        };
    }

    function update() {
        const total = getWeight() * getQty();
        const isBulk = total > LIMIT;
        const { add, bulk, buyNow } = getButtons();

        if (!add || !bulk) return;

        if (isBulk) {
            add.style.setProperty('display', 'none', 'important');
            bulk.style.setProperty('display', 'block', 'important');
            if (buyNow) {
                buyNow.disabled = true;
                buyNow.classList.add('disabled');
                buyNow.style.opacity = '0.5';
                buyNow.style.pointerEvents = 'none';
            }
        } else {
            add.style.setProperty('display', 'block', 'important');
            bulk.style.setProperty('display', 'none', 'important');
            if (buyNow) {
                buyNow.disabled = false;
                buyNow.classList.remove('disabled');
                buyNow.style.opacity = '';
                buyNow.style.pointerEvents = '';
            }
        }
    }

    document.addEventListener('input', (e) => {
        if (e.target.matches('.product-details input[name="quantity"], .quantity__input')) update();
    });

    document.addEventListener('variant:selected', () => { setTimeout(update, 150); });

    new MutationObserver(update).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-weight']
    });

    setInterval(update, 300);

    update();
})();


(function () {
    const inputs = document.querySelectorAll('.dynamic-search');
    if (!inputs.length) return;

    inputs.forEach((input) => {
        const baseText = input.getAttribute('data-base-text') || "";
        const words = (input.getAttribute('data-words') || "").split(',');

        let wordIndex = 0, charIndex = 0, isDeleting = false, typeSpeed = 100;

        function typeEffect() {
            const currentWord = words[wordIndex].trim();
            input.placeholder = baseText + currentWord.substring(0, charIndex);

            if (!isDeleting) {
                charIndex++;
                typeSpeed = 100;
                if (charIndex > currentWord.length) { isDeleting = true; typeSpeed = 2000; }
            } else {
                charIndex--;
                typeSpeed = 50;
                if (charIndex === 0) { isDeleting = false; wordIndex = (wordIndex + 1) % words.length; typeSpeed = 500; }
            }

            setTimeout(typeEffect, typeSpeed);
        }

        typeEffect();
    });
})();
